import { defaultParamsSerializer, handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import { useQuery } from '@tanstack/react-query';
import type { IEvent } from '@/interfaces';
import type { Paginated } from '@/lib/interface';
import { EventStatusEnum, EventTypeEnum } from '@/enums';
import routes from '@/lib/routes';

export type TGetEventsParams = {
	status?: EventStatusEnum[];
	type?: EventTypeEnum;
	startsAtFrom?: string;
	startsAtTo?: string;
	page?: number | string;
	limit?: number | string;
};

export const useRequestGetEvents = (params?: TGetEventsParams, run = true) => {
	const { invalidate } = useInvalidateQueries();

	const { isFetching, data, error } = useQuery({
		queryKey: [routes.api.events.base, params, run],
		queryFn: () =>
			!run
				? Promise.resolve(null)
				: apiClient
						.get<Paginated<IEvent>>(routes.api.events.base, params, {
							paramsSerializer: defaultParamsSerializer,
						})
						.then(handleApiResponse),
	});

	const refresh = () => invalidate(routes.api.events.base);

	return {
		data: data as Paginated<IEvent>,
		events: (data?.data ?? []) as IEvent[],
		isLoading: isFetching && !data,
		isFetching,
		refresh,
		error,
	};
};
